import { render } from "./Parents.vue?vue&type=template&id=3d4ebe02&scoped=true"
import script from "./Parents.vue?vue&type=script&lang=js"
export * from "./Parents.vue?vue&type=script&lang=js"

import "./Parents.vue?vue&type=style&index=0&id=3d4ebe02&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bmark-kid/bmark-kid-manage-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4ebe02"]])

export default __exports__